/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Empty_EyebrowInputs */

const en_us2_plan_build_empty_eyebrow = /** @type {(inputs: Plan_Build_Empty_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your plan is empty`)
};

const pt_br2_plan_build_empty_eyebrow = /** @type {(inputs: Plan_Build_Empty_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu plano está vazio`)
};

const es_419_plan_build_empty_eyebrow = /** @type {(inputs: Plan_Build_Empty_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu plan está vacío`)
};

const pt_pt2_plan_build_empty_eyebrow = /** @type {(inputs: Plan_Build_Empty_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O teu plano está vazio`)
};

const fr_fr2_plan_build_empty_eyebrow = /** @type {(inputs: Plan_Build_Empty_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton programme est vide`)
};

const de_de2_plan_build_empty_eyebrow = /** @type {(inputs: Plan_Build_Empty_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Plan ist leer`)
};

const it_it2_plan_build_empty_eyebrow = /** @type {(inputs: Plan_Build_Empty_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La tua scheda è vuota`)
};

/**
* | output |
* | --- |
* | "Your plan is empty" |
*
* @param {Plan_Build_Empty_EyebrowInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_empty_eyebrow = /** @type {((inputs?: Plan_Build_Empty_EyebrowInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Empty_EyebrowInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_empty_eyebrow(inputs)
	if (locale === "es-419") return es_419_plan_build_empty_eyebrow(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_empty_eyebrow(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_empty_eyebrow(inputs)
	if (locale === "de-DE") return de_de2_plan_build_empty_eyebrow(inputs)
	if (locale === "it-IT") return it_it2_plan_build_empty_eyebrow(inputs)
	return en_us2_plan_build_empty_eyebrow(inputs)
});
export { plan_build_empty_eyebrow as "plan-build.empty_eyebrow" }